import { ReactNode } from "react";
import { Card, Collapse } from "react-bootstrap";

import Button from "app/storybookComponents/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  title: ReactNode;
  setIsOpen: (val: boolean) => void;
  isOpen?: boolean;
  children?: ReactNode;
  className?: string;
  collapseText?: string;
  expandText?: string;
}

export default function SimpleCollapsibleCard({
  children,
  setIsOpen,
  isOpen,
  className = "",
  title,
  collapseText = "Collapse",
  expandText = "Expand",
}: Readonly<Props>) {
  const isCollapsed = !isOpen;
  const getTitle = () => {
    // if title is string wrap in h2 tag
    if (typeof title === "string") {
      return <h2>{title}</h2>;
    }
    return title;
  };
  return (
    <Card
      className={`simple-collapsible-card ${className}`}
      role={isCollapsed ? "button" : undefined}
      onClick={() => {
        if (isCollapsed) {
          setIsOpen(true);
        }
      }}
    >
      <div
        className="simple-collapsible-card__title"
        role={!isCollapsed ? "button" : undefined}
        onClick={() => {
          if (!isCollapsed) {
            setIsOpen(!isOpen);
          }
        }}
      >
        {getTitle()}
        <div>
          <Button variant="secondary-blue" className="border-0">
            {isCollapsed ? expandText : collapseText}
            <FontAwesomeIcon
              icon={`caret-${isCollapsed ? "down" : "up"}`}
              className="ms-2"
            />
          </Button>
        </div>
      </div>
      <Collapse in={isOpen}>
        <div>
          <div className="collapsed-container">{children}</div>
        </div>
      </Collapse>
    </Card>
  );
}
